import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as rmd from 'material-ui';
import req from 'superagent';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import BackIcon from 'material-ui/svg-icons/navigation/close';
import { IconMenuDefault, IconMenuClose, IconMenuOpen } from './svg/MenuIconSVG';
import auth from '../auth';
import _ from 'lodash';
import cx from 'classnames';
import { MainMenu, MainMenuMinimized } from './AppMenu';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { USER_ACTIONS } from '../reducers/user';
import { GlobalSnackBar } from './GlobalSnackbar';

import { fetchWidgetSpecs, fetchTemplates, fetchPortfolio } from 'dash-front/actions';

const SM_MUI_THEME = getMuiTheme({
    palette: {
        primary1Color: '#009688',
    },
    appBar: {
        height: 64,
    },
});
const DEFAULT_MUI_THEME = getMuiTheme({
    palette: {
        primary1Color: '#3F51B5',
    },
    appBar: {
        height: 64,
    },
});

class App extends React.Component {
    getChildContext() {
        return { user: auth.getUser() };
    }

    componentWillMount() {
        this.handleResize();
    }

    componentDidMount() {
        const { updateUser, removeUser, user, dispatch } = this.props;

        if (user) {
            req.get('/api/v2/me')
                .query({ access_token: auth.getAccessToken() })
                .then(({ body }) => {
                    auth.saveUser(body);
                    updateUser(body);

                    dispatch(fetchWidgetSpecs(user.defaultTemplateId));
                    dispatch(fetchPortfolio());
                    dispatch(fetchTemplates());
                })
                .catch(e => {
                    if ([401, 403].some(code => code === e.status)) {
                        removeUser();
                    }
                });

            // if (user && user.client) {
            //     // widgets/standalone/FixturesList/spec
            //     fetch(`${config.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}`)
            //         .then(response => response.json())
            //         .then(spec => {
            //             this.setState({ spec, isLoading: false });
            //         })
            //         .catch(err => {
            //             this.setState({ specError: err, isLoading: false });
            //         });
            // } else {
            //     console.warn('No user data in context', user);
            // }
        }

        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    state = {
        drawerOpen: false,
        minimizedMainMenu: true,
        menuIcon: <IconMenuDefault />,
    };

    static contextTypes = {
        router: PropTypes.object.isRequired,
    };

    static childContextTypes = {
        user: PropTypes.object,
    };

    logout = () => {
        const { removeUser } = this.props;
        removeUser();
        auth.logout();
        this.context.router.push('/login');
    };

    goToAccount = () => {
        this.context.router.push('/account');
    };

    openDrawer = () => {
        this.setState(
            {
                drawerOpen: !this.state.drawerOpen,
            },
            () => {
                this.setState({
                    menuIcon: !this.state.drawerOpen ? <IconMenuOpen /> : <IconMenuClose />,
                });
            },
        );
    };

    handleDrawerClose = menuItem => () => {
        this.setState({
            drawerOpen: false,
            menuIcon: <IconMenuOpen />,
        });
    };

    onRequestChange = () => () => {
        this.setState(
            {
                drawerOpen: !this.state.drawerOpen,
            },
            () => {
                this.setState({
                    menuIcon: !this.state.drawerOpen ? <IconMenuOpen /> : <IconMenuClose />,
                });
            },
        );
    };

    handleResize = () => {
        this.setState({
            minimizedMainMenu: !(window.innerWidth < 1200),
        });
    };

    render() {
        const { user } = this.props;
        const { menuIcon } = this.state;
        var nestedParams = _.clone(this.props.params);

        _.reduce(
            this.props.routes,
            (sum, item) => {
                return _.extend(sum, item.params);
            },
            nestedParams,
        );

        var showFooter = nestedParams.disableFooter !== true;
        const { disableHeader } = this.props.params;

        var doubleAppBar = nestedParams.doubleAppBar;
        var disableMiniMenu = nestedParams.disableMiniMenu;

        var isSM = window.location.href.indexOf('/sm/') !== -1;
        const muiTheme = DEFAULT_MUI_THEME;
        const appBarStyles = {
            zIndex: 1400,
        };

        if (doubleAppBar) appBarStyles.boxShadow = 'none';

        if (nestedParams.fullsize) {
            return (
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        background: '#f0f',
                        flex: 1,
                    }}
                >
                    <MuiThemeProvider muiTheme={muiTheme}>
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            {this.props.children || this.props.main}
                        </div>
                    </MuiThemeProvider>
                </div>
            );
        }

        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div
                    className={cx({
                        'menu-sticked': 1,
                        pane: nestedParams.pane,
                    })}
                >
                    <div id="wdp-top" />
                    <MainMenu
                        {...this.props}
                        drawerOpen={this.state.drawerOpen}
                        handleDrawerClose={this.handleDrawerClose}
                        onRequestChange={this.onRequestChange}
                        pathname={this.props.location.pathname}
                    />
                    {!disableHeader && (
                        <rmd.AppBar
                            className="main-bar"
                            title={this.props.menu || (user && `Hi, ${user.username}`) || 'WDP'}
                            style={appBarStyles}
                            iconElementLeft={
                                user ? <rmd.IconButton onClick={this.openDrawer}>{menuIcon}</rmd.IconButton> : null
                            }
                            showMenuIconButton={user !== null}
                            iconElementRight={
                                user && (
                                    <rmd.IconMenu
                                        iconButtonElement={
                                            <rmd.IconButton>
                                                <MoreVertIcon color="white" />
                                            </rmd.IconButton>
                                        }
                                        menuStyle={{
                                            zIndex: 10001,
                                            position: 'relative',
                                        }}
                                        style={{
                                            zIndex: 10001,
                                            position: 'relative',
                                        }}
                                        iconStyle={{ marginTop: 3 }}
                                        anchorOrigin={{
                                            horizontal: 'right',
                                            vertical: 'top',
                                        }}
                                        targetOrigin={{
                                            horizontal: 'right',
                                            vertical: 'top',
                                        }}
                                    >
                                        <rmd.MenuItem primaryText="Settings" onClick={this.goToAccount} />
                                        <rmd.MenuItem primaryText="Sign out" onClick={this.logout} />
                                    </rmd.IconMenu>
                                )
                            }
                        />
                    )}
                    <div
                        className={cx(nestedParams.container || 'container-fluid', 'page-wrap', {
                            disableFooter: !showFooter,
                            offsetLeft:
                                nestedParams.container !== 'container' &&
                                nestedParams.container !== 'container-white' &&
                                !disableMiniMenu,
                            disableHeader,
                            pane: nestedParams.pane,
                        })}
                    >
                        {user && !disableMiniMenu && this.state.minimizedMainMenu && (
                            <MainMenuMinimized {...this.props} drawerOpen={this.state.drawerOpen} />
                        )}
                        <div className="main-content">{this.props.children || this.props.main}</div>
                    </div>

                    {/* {showFooter && (
                        <footer className={!disableMiniMenu ? 'footer offsetLeft' : 'footer'}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-4">

                                    </div>
                                    <div className="col-md-4">
                                        <p>Documentation</p>
                                        <ul>
                                            <li>
                                                <a
                                                    href="https://releaze.atlassian.net/wiki/display/wdp/Using+WDP"
                                                    target="_blank"
                                                >
                                                    Using WDP
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://releaze.atlassian.net/wiki/display/wdp/Integration+manual">
                                                    Developer guide
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="https://releaze.atlassian.net/wiki/display/wdp/FAQ"
                                                    target="_blank"
                                                >
                                                    FAQ
                                                </a>
                                            </li>
                                            <li className="coming-soon">
                                                <a href="#">Examples</a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="col-md-4"
                                        <p>Support</p>
                                        <ul>
                                            <li>
                                                <a target="_blank" href="https://join.skype.com/gfb2fcPCAySI">
                                                    Join support chat
                                                </a>
                                            </li>
                                            <li className="coming-soon">
                                                <a href="#">Contacts</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    )} */}
                    <GlobalSnackBar />
                </div>
            </MuiThemeProvider>
        );
    }
}

App.propTypes = {
    user: PropTypes.object,
    updateUser: PropTypes.func.isRequired,
    removeUser: PropTypes.func.isRequired,
};

export default connect(
    state => ({
        user: state.user,
    }),
    dispatch => ({
        dispatch,
        updateUser: user => dispatch({ type: USER_ACTIONS.UPDATE, payload: user }),
        removeUser: () => dispatch({ type: USER_ACTIONS.LOGOUT }),
    }),
)(App);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/App.js
 **/